import bs from './bs.json'
import srLatn from './sr-Latn.json'
import hr from './hr.json'

/* UI text in three variants (spec 1a). Every string lives in the JSON files;
   a message is a string or, for counts, { one, few, other } (ICU plural
   categories, the same rules in all three variants). {name} placeholders are
   filled from `vars`. News titles are never translated. */
const MESSAGES = { bs, 'sr-Latn': srLatn, hr }

// Country from the time zone, for browsers set to another language (spec 1a,
// step 2), without asking for location.
const ZONE_LANG = {
  'Europe/Sarajevo': 'bs',
  'Europe/Belgrade': 'sr-Latn',
  'Europe/Zagreb': 'hr',
}

export function detectLanguage() {
  const languages =
    (typeof navigator !== 'undefined' && (navigator.languages || [navigator.language])) || []
  for (const tag of languages) {
    const code = String(tag || '').toLowerCase()
    if (code.startsWith('bs')) return 'bs'
    if (code.startsWith('hr')) return 'hr'
    if (code.startsWith('sr')) return 'sr-Latn' // sr-Cyrl comes later
  }
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (ZONE_LANG[zone]) return ZONE_LANG[zone]
  } catch (e) {
    // no Intl time zone: fall through
  }
  return 'bs'
}

export const LANG = detectLanguage()
// Value for <html lang> and the API's ?lang=.
export const HTML_LANG = LANG === 'sr-Latn' ? 'sr-Latn' : LANG

const pluralRules = new Intl.PluralRules(LANG === 'sr-Latn' ? 'sr' : LANG)

function lookup(messages, key) {
  return key.split('.').reduce((node, part) => (node == null ? node : node[part]), messages)
}

function fill(template, vars) {
  return template.replace(/\{(\w+)\}/g, (match, name) =>
    vars && name in vars ? vars[name] : match
  )
}

/* t('nav.home'), t('feed.sources', { count: 18 }) */
export function t(key, vars) {
  let message = lookup(MESSAGES[LANG], key)
  if (message == null) message = lookup(MESSAGES.bs, key)
  if (message == null) return key
  if (typeof message === 'object') {
    const count = vars?.count ?? 0
    message = message[pluralRules.select(count)] ?? message.other
  }
  return fill(message, vars)
}
